var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6665 3.33301H3.83317C3.39114 3.33301 2.96722 3.5086 2.65466 3.82116C2.3421 4.13372 2.1665 4.55765 2.1665 4.99967V16.6663C2.1665 17.1084 2.3421 17.5323 2.65466 17.8449C2.96722 18.1574 3.39114 18.333 3.83317 18.333H15.4998C15.9419 18.333 16.3658 18.1574 16.6783 17.8449C16.9909 17.5323 17.1665 17.1084 17.1665 16.6663V10.833",
    stroke: "#1E2228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9165 2.0832C16.248 1.75168 16.6977 1.56543 17.1665 1.56543C17.6353 1.56543 18.085 1.75168 18.4165 2.0832C18.748 2.41472 18.9343 2.86436 18.9343 3.3332C18.9343 3.80204 18.748 4.25168 18.4165 4.5832L10.4998 12.4999L7.1665 13.3332L7.99984 9.99986L15.9165 2.0832Z",
    stroke: "#1E2228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7f7cfad90631d5d121b8b40ff6d30882.svg";
export { ForwardRef as ReactComponent };